import { defineTable } from "convex/server";
import { v } from "convex/values";
import { internalControl } from "../../../lib/shared/validators";

export const boxDeliveryStatus = v.union(
  v.literal("pending_use"),
  v.literal("picked_up"),
  v.literal("used"),
  v.literal("forfeited"),
);

export const validatorBoxDelivery = v.object({
  clientId: v.id("clients"),
  boxTypeId: v.id("box_types"),
  quantity: v.number(),
  depositAmount: v.number(),
  qrCode: v.string(),
  status: boxDeliveryStatus,
  deliveredAt: v.number(),
  deliveredBy: v.id("users"),
  // Picked up (physically collected, but not yet linked to a package)
  pickedUpAt: v.optional(v.number()),
  pickedUpBy: v.optional(v.id("users")),
  // Used (linked to a package/order)
  usedAt: v.optional(v.number()),
  usedBy: v.optional(v.id("users")),
  packageId: v.optional(v.id("packages")),
  forfeitedAt: v.optional(v.number()),
  forfeitedBy: v.optional(v.id("users")),
  forfeitReason: v.optional(v.string()),
  expiresAt: v.optional(v.number()),
  notes: v.optional(v.string()),
  // Pickup evidence (when box is collected)
  pickupWeight: v.optional(v.number()),
  pickupDescription: v.optional(v.string()),
  pickupPhotos: v.optional(v.array(v.id("_storage"))),
  pickupNotes: v.optional(v.string()),
  internalControl: internalControl,
});

export const box_deliveries = defineTable(validatorBoxDelivery)
  .index("by_company_id", ["internalControl.companyId"])
  .index("by_branch_id", ["internalControl.branchId"])
  .index("by_state", ["internalControl.state"])
  .index("by_company_and_state", [
    "internalControl.companyId",
    "internalControl.state",
  ])
  .index("by_company_and_branch", [
    "internalControl.companyId",
    "internalControl.branchId",
  ])
  .index("by_created_at", ["internalControl.createdAt"])
  .index("by_company_and_created_at", [
    "internalControl.companyId",
    "internalControl.createdAt",
  ])
  .index("by_status", ["status"])
  .index("by_company_and_status", ["internalControl.companyId", "status"])
  .index("by_client", ["clientId"])
  .index("by_company_and_client", ["internalControl.companyId", "clientId"])
  .index("by_client_and_status", ["clientId", "status"])
  .index("by_company_client_status", [
    "internalControl.companyId",
    "clientId",
    "status",
  ])
  .index("by_box_type", ["boxTypeId"])
  .index("by_qr_code", ["qrCode"])
  .index("by_package", ["packageId"])
  .searchIndex("search_box_deliveries", {
    searchField: "qrCode",
    filterFields: [
      "internalControl.companyId",
      "internalControl.state",
      "status",
      "clientId",
    ],
  });
